<h2 class="header">Salgsstart</h2>

<div class="timeperiod">
    <ev-time-period-filter
        [showAllOptionInRange]="true"
        [rangeTitle]="'Periode tilbake i tid'"
        [rangeToMonthList]="rangeToMonthList"
        [defaultValue]="defaultValue"
        [selectedPeriod]="selectedValue"
        (onTimePeriodChange)="onChange($event)"
    ></ev-time-period-filter>
</div>
